import { graphql, useFragment } from "react-relay";

import { PropsWithChildren } from "react";
import { GenericTypeaheadOption, MenuListItemProps } from "./type";
import EntityProfilePic from "../../../EntityProfilePic";
import { cn } from "../../../../utils/tailwind";
import { ItemSuggestionEntityFragment$key } from "./__generated__/ItemSuggestionEntityFragment.graphql";

export const ItemSuggestionEntityFragment = graphql`
  fragment ItemSuggestionEntityFragment on Entity {
    id
    username
    displayName
    ...EntityProfilePicFragment @arguments(thumbnail: true)
  }
`;

function ItemSuggestion({
  index,
  isSelected,
  onClick,
  onMouseEnter,
  setRefElement,
  children,
}: Readonly<
  PropsWithChildren<
    MenuListItemProps & { setRefElement: (element: HTMLElement | null) => void }
  >
>) {
  return (
    <li
      tabIndex={-1}
      className={cn("cursor-pointer py-1 rounded", {
        "bg-brand-500/5": isSelected,
      })}
      role="option"
      aria-selected={isSelected}
      id={`typeahead-item-${index}`}
      onMouseEnter={onMouseEnter}
      onClick={onClick}
      ref={setRefElement}
      data-index={index}
    >
      {children}
    </li>
  );
}

interface ItemEntityProps extends MenuListItemProps {
  option: GenericTypeaheadOption<ItemSuggestionEntityFragment$key>;
}

function ItemSuggestionEntity({
  index,
  isSelected,
  onClick,
  onMouseEnter,
  option,
}: ItemEntityProps) {
  const entity = useFragment(ItemSuggestionEntityFragment, option.node);
  return (
    <ItemSuggestion
      index={index}
      isSelected={isSelected}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      setRefElement={option.setRefElement}
    >
      <div
        role="presentation"
        className="flex flex-row gap-2 items-center mx-2 my-1"
      >
        <EntityProfilePic entity={entity} size="8" />
        <span className="text-black">
          <strong>{entity.username}</strong> <small>{entity.displayName}</small>
        </span>
      </div>
    </ItemSuggestion>
  );
}

ItemSuggestion.Entity = ItemSuggestionEntity;
export default ItemSuggestion;
